<span *ngIf="status" [class]="class">{{ statusDescription|customtitleCase }}</span>
 